import {Helmet} from "react-helmet-async";
import {Navigate, useParams} from "react-router";

import ContentContainer from "@/components/layout/ContentContainer.tsx";
import {UpErrorBoundary} from "@/lib/handlers/UpErrorBoundary.tsx";
import {PageSpeedDetailsContent} from "@/pages/pagespeed/PageSpeedDetailsContent.tsx";

export const PageSpeedDetails = () => {
  const {id} = useParams();
  const checkID = parseInt(id!);

  if (isNaN(checkID)) {
    return <Navigate to="/not-found" replace />;
  }

  return (
    <ContentContainer contentClass="pagespeed">
      <Helmet>
        <title>Page Speed Check Analysis</title>
      </Helmet>
      <UpErrorBoundary>
        <PageSpeedDetailsContent id={checkID} />
      </UpErrorBoundary>
    </ContentContainer>
  );
};
